import { Component, Input, OnChanges } from '@angular/core';

import { Data2Service } from '../../common/data2.service';

import { Lead } from '../leads.model';

@Component({
	selector: 'app-leads-show-detail',
	templateUrl: './leads-show-detail.component.html',
	styleUrls: ['./leads-show-detail.component.css'],
})
export class LeadsShowDetailComponent implements OnChanges {
	@Input() lead: Lead;
	@Input() types: Array<any>;
	@Input() sources: Array<any>;
	@Input() users: Array<any>;
	sourceName = '';
	ownerName = '';
	details = '';

	constructor(private readonly api: Data2Service) {}

	ngOnChanges(): void {
		if (!this.lead || !this.types || !this.sources || !this.users) {
			return;
		}
		switch (this.lead.source) {
			case 2:
				this.api.command(
					'/leads/',
					{
						cmd: 'getFacebookAdByExternalId',
						externalId: this.lead.externalType,
					},
					(result, error) => {
						this.details = result?.data?.name;
					},
				);
				break;
			case 12:
				this.api.command(
					'/leads/',
					{
						cmd: 'getOfferByExternalId',
						externalId: this.lead.externalId,
					},
					(result, error) => {
						this.details = result?.data?.name;
					},
				);
				break;
			case 14:
				this.api.command(
					'/leads/',
					{
						cmd: 'getOfferGroupByExternalId',
						externalId: this.lead.externalId,
					},
					(result, error) => {
						this.details = result?.data?.name;
					},
				);
				break;
		}

		this.lead.type = this.findIt(this.types, this.lead.type);
		this.sourceName = this.findIt(this.sources, this.lead.source);
		this.ownerName = this.findIt(this.users, this.lead.owner);
	}

	private findIt(objects, findObj) {
		const found = objects.find((obj) => obj.id == findObj);
		return found ? found.name : '?';
	}
}
